<template>
    <div class="card border-white bg-transparent mb-4 font-weight-bold" style="border-width: 8px">
        <div class="card-body p-print-0">
            <div class="row gy-4">
                <div class="col-md-6">
                    <CourseTag :course="course" />

                    <template v-if="course.details && course.details.length > 0">
                        <ul class="text-primary list-unstyled mb-n3 mt-4">
                            <template v-for="detail in course.details">
                                <li class="mb-3">
                                    <DetailItem :detail="detail" />
                                </li>
                            </template>
                        </ul>
                    </template>
                </div>
                <div class="col-md-6">
                    <div class="row justify-content-between">
                        <template v-if="course.contacts && course.contacts.length > 0">
                            <div class="col-lg-6" style="min-width: 0">
                                <div class="course-page__infos mb-n3">
                                    <div class="mb-3">
                                        <div class="cursus-badge">
                                            Contacts
                                        </div>
                                    </div>

                                    <template v-for="contact in course.contacts">
                                        <div class="mb-3 pb-1">
                                            <div class="cursus-content" v-html="contact.content">
                                            </div>
                                            <template v-if="contact.contact_url">
                                                <div class="d-print-none">
                                                    <a :href="contact.contact_url" style="text-decoration: underline">
                                                        mail
                                                    </a>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>

                        <template v-if="course.attachments && course.attachments.length > 0">
                            <div class="col-lg-auto">
                                <div class="mb-4">
                                    <div class="row mx-n2 mb-n3">
                                        <template v-for="attachment in course.attachments">
                                            <div class="col-6 col-sm-auto px-2 mb-3" style="max-width: 140px">
                                                <div class="course-attachment position-relative">
                                                    <div class="course-attachment__image-container border border-primary">
                                                        <template v-if="attachment.thumbnail">
                                                            <img class="course-attachment__image" :src="attachment.thumbnail" :alt="attachment.title || attachment.name">
                                                        </template>
                                                        <template v-else>
                                                            <div class="course-attachment__placeholder d-flex justify-content-center align-items-center bg-white">
                                                                <Icon name="file-placeholder" class="text-primary" width="53%" height="44%" />
                                                            </div>
                                                        </template>
                                                    </div>

                                                    <div class="mt-2">
                                                        <a class="course-attachment__label stretched-link" :href="attachment.url">
                                                            {{ attachment.title || attachment.name }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import CourseTag from "../../ui/CourseTag.vue";
    import Icon from "../../ui/Icon.vue";
    import CustomText from "../../ui/CustomText.vue";
    import DetailItem from "../../ui/DetailItem.vue";

    export default {
        components: {
            DetailItem,
            CustomText,
            Icon,
            CourseTag,
        },
        props: {
            course: Object,
        },
        methods: {
            info(type) {
                return this.course.details?.find(detail => detail.type === type)?.text;
            },
        },
    }
</script>
